import React, { useEffect, useState, useCallback } from "react";
import Marquee from "react-fast-marquee";
import Styles from "./DamStrip.module.css";
import { getDamData } from "../../../../Services/BuySell/Listing";
import { formatDateType } from "../../../../commons/FormatDate";

const DamStrip = ({ speed = 50, pauseOnHover = true }) => {
  const [damData, setDamData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchDamData = useCallback(async () => {
    try {
      setLoading(true);
      setError(false);
      const data = await getDamData();
      setDamData(data);
    } catch (err) {
      console.error("Error fetching DAM data:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDamData();
  }, [fetchDamData]);

  const renderContent = () => {
    if (loading) {
      return (
        <div style={{ display: "flex", gap: "10px" }}>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className={Styles.stripBox}>
          <div className={Styles.error}>
            <span>⚠️</span> Failed to load DAM data
          </div>
        </div>
      );
    }

    return (
      <div style={{ display: "flex" }}>
        <div style={{ margin: "0px 10px" }} className={Styles.stripBox}>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            Current DAM{" "}
            <span style={{ color: "#34656d", fontSize: "8px" }}>
              (Date : {formatDateType(damData?.date)})
            </span>
            :-
          </div>
          <div>
            {damData?.cur_day
              ? `${Number(damData.cur_day).toFixed(3)} ₹/kWh`
              : "-"}
          </div>
        </div>
        <div style={{ margin: "0px 10px" }} className={Styles.stripBox}>
          <div>Previous DAM:-</div>
          <div>
            {damData?.prev_day
              ? `${Number(damData.prev_day).toFixed(3)} ₹/kWh`
              : "-"}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={Styles.scheduleStrip}>
      <Marquee
        pauseOnHover={pauseOnHover}
        gradient={false}
        speed={speed}
        autoFill={!loading && !error}
        play={!loading}
      >
        {renderContent()}
      </Marquee>
    </div>
  );
};

export default DamStrip;
